module.exports = __webpack_public_path__ + "img/home_adapt_vertical_delete_normal.1cc214ca.svg";